/* eslint-disable */
import { FILTER_ADDRESS_ADDED } from '../Filters.types';

/**
 * Action to add the address to the filters
 * @param {Array} address The address
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_ADDED>>} The created `Action`
 */
const filtersAddAddress = (address) => ({ fromPayload }) => {
  return fromPayload(address, { debounce: true }, FILTER_ADDRESS_ADDED);
};

export default filtersAddAddress;
